import { omit } from 'lodash';
import { format } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import { DrivingLogCreateForm, DrivingLogEntryRequest } from '@/features/myTrips/types/DrivingLog';

/**
 * Builds the create/update payload for a driving-log entry. The form keeps the date and the
 * `HH:mm` time in separate fields, both as wall-clock values in the branch's time zone; the API
 * takes them as a single `startedAt` instant.
 *
 * The date and time are combined as text rather than on a `Date`: setting hours on a `Date`
 * resolves them in the browser's zone, which moves a time that falls in the browser's DST gap
 * even when it is perfectly valid in the branch's zone.
 */
export const toDrivingLogEntryRequest = (
  values: DrivingLogCreateForm & Required<Pick<DrivingLogCreateForm, 'startDate'>>,
  timeZoneId: string,
): DrivingLogEntryRequest => {
  const day = format(new Date(values.startDate), 'yyyy-MM-dd');
  const time = values.startTime?.slice(0, 5) || '00:00';

  return {
    ...omit(values, ['startDate', 'startTime']),
    startedAt: fromZonedTime(`${day}T${time}`, timeZoneId).toISOString(),
  };
};
